import React, { useState, useRef, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import Header from './Header';

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(() => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  width: '100%',
  height: '100vh',
  backdropFilter: 'blur(5px)',
}));

export default function SimpleLayout() {
  const [open, setOpen] = useState(false);
  const [currentPosition, setCurrentPosition] = useState(0);
  const mainRef = useRef(null);

  useEffect(() => {
    const mainRefCurrent = mainRef.current;

    const handleScroll = () => {
      if (mainRefCurrent) {
        setCurrentPosition(mainRefCurrent.scrollTop);
      }
    };

    if (mainRefCurrent) {
      mainRefCurrent.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (mainRefCurrent) {
        mainRefCurrent.removeEventListener('scroll', handleScroll);
      }
    };
  }, [mainRef]);

  return (
    <StyledRoot>
      <Header currentPosition={currentPosition} onOpenNav={() => setOpen(true)} open={open} setOpen={setOpen} />
      <Main ref={mainRef}>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
